import React from 'react';
import ShortcutsSettingsSection from './settings/ShortcutsSettingsSection';
import TagsSettingsSection from './settings/TagsSettingsSection';
import BusinessHoursSettingsSection from './settings/BusinessHoursSettingsSection';
import AutomaticMessagesSettingsSection from './settings/AutomaticMessagesSettingsSection';

const SettingsView = ({ activeSubTab = 'atajos' }) => {
  return (
    <div>
      {activeSubTab === 'atajos' && <ShortcutsSettingsSection />}
      {activeSubTab === 'horarios' && <BusinessHoursSettingsSection />}
      {activeSubTab === 'incidencias' && <TagsSettingsSection />}
      {activeSubTab === 'mensajes' && <AutomaticMessagesSettingsSection />}
    </div>
  );
};

export default SettingsView;


